import { useDraggable } from "@dnd-kit/core";
import { useSelector } from "react-redux";

export const Draggable = (props) => {
  const { id, styles = {}, onClick = () => {}, origin, isDragging } = props;
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: id,
  });

  const isAnimating = useSelector((state) => state.game.isAnimating);

  const style = transform
    ? {
        ...styles,
        transform: `translate(${transform.x}px, ${transform.y}px)`,
      }
    : styles;

  const handleClick = () => {
    if (isDragging) return;
    onClick(id);
  };

  return (
    <button
      type="button"
      data-origin={origin}
      ref={setNodeRef}
      style={{ ...style, userSelect: "none", touchAction: "none" }}
      {...attributes}
      {...listeners}
      onClick={handleClick}
      disabled={isAnimating}
    >
      {props.children}
    </button>
  );
};
